<template>
  <div class="general-tab">
    <winding-temperature-section
      :winding-temperature-charts="windingTemperatureCharts"
      :winding-amount="tabInfo.windingAmount"
      :loading="loadingWindingCharts"
    />
    <water-on-paper-dry-mass-section
      class="mt-3 avoid-break"
      :water-on-paper-dry-mass-charts="waterOnPaperDryMassCharts"
      :winding-amount="tabInfo.windingAmount"
      :loading="loadingWaterOnPaperDryMass"
    />
    <general-tab-cards-section
      class="mt-3 avoid-break"
      :cards="cards"
      :loading="loadingCards"
    />
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import Service from '@/domain/services/installation/engineering/waterOnPaper/waterOnPaperService';
import GeneralTabCardsSection from '@/domain/components/installation/engineering/waterOnPaper/GeneralTabCardsSection';
import WindingTemperatureSection from './WindingTemperatureSection';
import WaterOnPaperDryMassSection from './WaterOnPaperDryMassSection';

export default {
  name: 'WaterOnPaperGeneralTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GeneralTabCardsSection,
    WindingTemperatureSection,
    WaterOnPaperDryMassSection,
  },
  data: () => ({
    cards: [],
    windingTemperatureCharts: [],
    waterOnPaperDryMassCharts: [],
    loadingCards: false,
    windingTemperatureCollapsed: false,
    loadingWindingCharts: false,
    loadingWaterOnPaperDryMass: false,
    chartData: {},
  }),
  created() {
    this.init();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshDataEvent, this);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshDataEvent, this);
    },
    refreshData(showLoading) {
      if (!this.tabInfo.windingAmount) return;
      this.getCards(showLoading);
      this.getWindingCharts(showLoading);
      this.getWaterOnPaperDryMassCharts(showLoading);
    },
    getCards(showLoading = false) {
      this.loadingCards = showLoading;
      Service.getCards(this.$route.params.assetModuleId).then((response) => {
        this.cards = response;
      }).finally(() => {
        this.loadingCards = false;
      });
    },
    getWindingCharts(showLoading = false) {
      const { assetModuleId } = this.$route.params;
      const { windingAmount } = this.tabInfo;
      const promises = [];
      const responses = [];
      this.loadingWindingCharts = showLoading;

      for (let index = 1; index <= windingAmount; index += 1) {
        promises.push(Service.getWindingTemperatureChart(assetModuleId, index));
      }
      return Promise.allSettled(promises).then((response) => {
        response.forEach(windingChart => responses.push(windingChart.value));
      }).finally(() => {
        this.windingTemperatureCharts = responses;
        this.loadingWindingCharts = false;
      });
    },
    getWaterOnPaperDryMassCharts(showLoading = false) {
      const { assetModuleId } = this.$route.params;
      const { windingAmount } = this.tabInfo;
      const promises = [];
      const responses = [];
      this.loadingWaterOnPaperDryMass = showLoading;

      for (let index = 1; index <= windingAmount; index += 1) {
        promises.push(Service.getDryMassChart(assetModuleId, index));
      }
      return Promise.allSettled(promises).then((response) => {
        response.forEach(windingChart => responses.push(windingChart.value));
      }).finally(() => {
        this.waterOnPaperDryMassCharts = responses;
        this.loadingWaterOnPaperDryMass = false;
      });
    },
    refreshDataEvent(showLoading = false) {
      this.refreshData(showLoading);
    },
  },
};
</script>

<style lang="sass" scoped>
.general-tab
  page-break-after: always
</style>
